import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContacterCafPrimoCourrielComponent } from './05-contactermacaf-primoparcourriel/contactercafprimocourriel.component';
import { ContacterCafCourrielComponent } from './03-contactermacaf-parcourriel/contactercafcourriel.component';
import { ContacterMaCafCompletComponent } from './01-contactermacaf-complet/contactermacafcomplet.component';
import { ContacterCafCourrielReponsesComponent } from './10-contactermacaf-reponses/contactercafcourrielreponses.component';
import { ContacterMaCafEchecSviComponent } from './contactermacaf-echec-svi/contactermacaf-echec-svi.component';
import {ContactermacafMotifsdecontactComponent} from './contactermacaf-motifsdecontact/contactermacaf-motifsdecontact.component';
import {MotifsdecontactDelaisDeTraitementComponent} from './contactermacaf-motifsdecontact/parcours/delaisdetraitement/motifsdecontact-delaisdetraitement.component';
import {MotifsdecontactChangementDeSituationComponent} from './contactermacaf-motifsdecontact/parcours/changementdesituation/motifsdecontact-changementdesituation.component';
import { MotifsdecontactActualitesComponent } from './contactermacaf-motifsdecontact/parcours/actualites/motifsdecontact-actualites.component';
import { MotifsdecontactAutremotifComponent } from './contactermacaf-motifsdecontact/parcours/autremotif/motifsdecontact-autremotif.component';
import { MotifsdecontactDettesComponent } from './contactermacaf-motifsdecontact/parcours/dettes/motifsdecontact-dettes.component';
import { ForteAffluenceComponent } from './contactermafcaf-forteaffluence-svi/contactermacaf-forteaffluence-svi.component';

export const routesName = {
  routeContactcaf : 'contactcaf',
  routeContactcafcourriel : 'contactcafcourriel',
  routeContactcafprimocourriel : 'contactcafprimocourriel',
  routeContactcafEchecSvi: 'contactcafechecsvi',
  routeMotifsDeContact: 'motifsdecontact',
  delaisDeTraitement:'motifsdecontact/delaisdetraitement',
  changementDeSituation:'motifsdecontact/changementdesituation',
  dettes:'motifsdecontact/dettes',
  actualites:'motifsdecontact/actualites',
  autremotif:'motifsdecontact/autremotif',
  forteaffluence: 'forteaffluence'
};

export const routes: Routes = [
  { path: routesName.routeContactcafprimocourriel, component: ContacterCafPrimoCourrielComponent },
  { path: routesName.routeContactcafcourriel, component: ContacterCafCourrielComponent,
    children: [
      { path: 'reponses', component: ContacterCafCourrielReponsesComponent }
    ]
  },
  { path: routesName.routeContactcafEchecSvi, component: ContacterMaCafEchecSviComponent },
  { path: routesName.routeContactcaf, component: ContacterMaCafCompletComponent},
  { path: routesName.routeMotifsDeContact, component: ContactermacafMotifsdecontactComponent},
  { path: routesName.delaisDeTraitement, component: MotifsdecontactDelaisDeTraitementComponent}, 
  { path: routesName.changementDeSituation, component: MotifsdecontactChangementDeSituationComponent},
  { path: routesName.dettes, component: MotifsdecontactDettesComponent},
  { path: routesName.actualites, component: MotifsdecontactActualitesComponent},
  { path: routesName.autremotif, component: MotifsdecontactAutremotifComponent},
  { path: routesName.forteaffluence, component: ForteAffluenceComponent},
  {
    path: '**',
    redirectTo: 'contactcaf',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, anchorScrolling: 'enabled', onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
/**
 * CE FICHIER PEUT ETRE SUPPRIMER S'IL N'Y A PAS BESOIN DE ROUTE
 */
